import { getEnv } from "@ace/env";
import { useEffect, useState } from "react";

export interface Product {
  productId: number;
  name: string;
  created: string;
  updated: string;
  managedBy: string;
}

interface UseProducts {
  products: Product[];
  loadingProducts: boolean;
}

/**
 * These are the full names for the ```productId```'s that come back on most of the ace websocket data relating to assets, accounts and trading-pairs.
 */
export const useProducts: () => UseProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loadingProducts, setLoading] = useState(true);

  useEffect(() => {
    const getProducts = async () => {
      const response = await fetch(
        `${getEnv(
          "VITE_ACE_WEB_AUTH_SERVER",
        )}/rest-gateway/general-ledger/product`,
        {
          method: "GET",
        },
      );
      const json = await response.json();

      if (json.status === "ERROR") {
        setLoading(false);
        throw new Error(json.error[0].msg);
      }

      setLoading(false);
      setProducts(json.data);
    };

    getProducts();
  }, []);

  return {
    products,
    loadingProducts,
  };
};
